<template>
  <section>
    <CCard class="w-100 mb-3 mt-3 p-3" v-for="(item, i) in items" :key="item.title + i">
      <CButton block class="text-left shadow-none card-header" @click="accordion = accordion === item.title ? false : item.title">
        <h5 style="color: #343a40" class="m-0">{{ item.title }}</h5>
        <CIcon v-if="accordion != item.title || accordion === false" class="plusIcon mr-2" name="plus" :height="15" viewBox="0 0 32 32" />
        <CIcon v-if="accordion == item.title" class="plusIcon mr-2" name="minus" :height="15" viewBox="0 0 32 32" />
      </CButton>
      <CCollapse :show="accordion === item.title">
        <CCardBody>
          <div v-html="item.answers"></div>
        </CCardBody>
      </CCollapse>
    </CCard>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'NeedSomething',
  props: {
    contentName: {
      type: String,
      default: null,
      required: true,
    },
  },

  data() {
    return {
      collapse: false,
      cardCollapse: true,
      innerCollapse: false,
      accordion: '',
      items: [],
    }
  },
  computed: {
    ...mapGetters({
      lang: 'getLang',
    }),
  },
  mounted() {
    this.updateItems()
  },
  methods: {
    updateItems() {
      this.items = this.$t(`faqs.quetions.pages.${this.contentName}.content`)
    },
  },

  watch: {
    lang: {
      handler() {
        this.updateItems()
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.askSubTitle {
  color: #868e96;
  font-size: 18px;
}

.plusIcon {
  position: absolute;
  right: 25px;
  top: 40%;
}
</style>
